import React from "react";
import {FaAngry, FaRegFrownOpen, FaSmile} from "react-icons/fa";
import {Link} from "react-router-dom";
import {useRegisterContext} from "../../context/ContextProvider";

const Success = () => {
  const {setActiveStyle} = useRegisterContext();

  return (
    <div className="container success__container">
      <div className="sticker__feedback-container">
        <h1>Rate your experience</h1>
        <div className="stickers">
          <div className="sticker__container">
            <FaAngry className="sticker__icon" />
            <p>Bad</p>
          </div>
          <div className="sticker__container">
            <FaRegFrownOpen className="sticker__icon" />
            <p>Mixed</p>
          </div>
          <div className="sticker__container">
            <FaSmile className="sticker__icon" />
            <p>Happy</p>
          </div>
        </div>
      </div>
      <textarea placeholder="Tell us more"></textarea>
      <div className="email__container">
        <label>Email address </label>
        <input type="email"></input>
      </div>
      <Link to="/">
        <button onClick={() => setActiveStyle(1)}>Submit</button>
      </Link>
    </div>
  );
};

export default Success;
